import { useCallback, useSyncExternalStore } from 'react';
import { useSlateStatic } from '../../core';
import type { EditableProps } from '../../core';
import { getDictationCheckStore } from './store';

// Called in the enhanced Editable component through the existing props-transform pipeline.
// Only editors with DictationCheckPlugin installed execute these hooks.
export function useDictationCheckEditable(props: EditableProps): EditableProps {
  const editor = useSlateStatic();
  const store = getDictationCheckStore(editor);
  const snapshot = useSyncExternalStore(store.subscribe, store.getSnapshot);
  const baseDecorate = props.decorate;
  const decorate = useCallback<NonNullable<EditableProps['decorate']>>(
    (entry) => {
      // Invalidate Slate's decoration cache on publication, without changing renderLeaf identity.
      void snapshot;
      return baseDecorate?.(entry) ?? [];
    },
    [baseDecorate, snapshot]
  );
  return { ...props, decorate };
}
